const ProgressNumbers = (routeView) => {
  const {
    route: {
      totalStops,
      actualDepartures,
      canceledStops,
      redeliveredStops,
      undeliveredStops
    } = {},
    stopStats: {
      cloned,
      planned
    } = {}
  } = routeView;

  const routeNumbers = {
    total: totalStops || 0,
    delivered: routeView?.stopStats?.delivered ?? actualDepartures ?? 0,
    canceled: routeView?.stopStats?.canceled ?? canceledStops ?? 0,
    redelivery: routeView?.stopStats?.redelivery ?? redeliveredStops ?? 0,
    undelivery: routeView?.stopStats?.undeliverable ?? undeliveredStops ?? 0,
    partial: routeView?.stopStats?.partiallyDelivered ?? 0
  };

  const {
    delivered,
    canceled,
    redelivery,
    undelivery,
    partial,
    total
  } = routeNumbers;
  const totalDone = delivered + canceled + redelivery + undelivery + partial;
  const progress = (totalDone)
    ? parseInt(((totalDone / total) * 100), 10) : 0;

  routeNumbers.done = delivered;
  routeNumbers.progress = progress;
  routeNumbers.progressText = `${totalDone}/${total} (${progress}%)`;
  routeNumbers.progressCanceled = `${(canceled) ? ((canceled / total) * 100).toFixed(0) : 0}%`;
  routeNumbers.progressUndelivered = `${(undelivery) ? ((undelivery / total) * 100).toFixed(0) : 0}%`;
  routeNumbers.progressRedelivered = `${(redelivery) ? ((redelivery / total) * 100).toFixed(0) : 0}%`;
  routeNumbers.progressPartial = `${(partial) ? ((partial / total) * 100).toFixed(0) : 0}%`;
  routeNumbers.progressDelivered = `${(delivered) ? ((delivered / total) * 100).toFixed(0) : 0}%`;
  routeNumbers.totalDone = totalDone;
  routeNumbers.cloned = cloned;
  routeNumbers.planned = planned;

  return routeNumbers;
};

export default ProgressNumbers;
